import { defineMessages } from "react-intl";

export const generalText = defineMessages({
  close: {
    id: "general.close",
    defaultMessage: "Close",
  },
});
